import Navigation from "./libs/Navigation";
import Search from "./libs/Search";
import LoanSlider from "./libs/LoanSlider";
import LoanConfigFactory from "./libs/LoanConfigFactory";
import LoanReviewCard from "./libs/LoanReviewCard";
import { Swiper, Navigation as SN, Pagination } from "swiper";
import ListSection from "./libs/ListSection";
import Modal from "./libs/Modal";
import Storage from "./libs/Storage";
import { initAdsModal, initGDPR } from "./libs/functions";
import { createPopper } from "@popperjs/core";
import StarRating from "star-rating.js";
// import { version } from "react-dom";

Swiper.use([SN, Pagination]);

document.addEventListener("DOMContentLoaded", function () {
  let loans = document.querySelectorAll('.loan-review-card');

  loans.forEach(x => new LoanReviewCard(x));

  let storage = new Storage();

  initGDPR(storage);

  /* eslint-disable */
  initAdsModal(".ads-trigger", configs);

  new Search(
    ".search-icon",
    ".search-container",
    new Navigation().init(".nav-primary")
  );

  new Swiper(".clients-review-section--list", {
    slidesPerView: 1,
    centeredSlides: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    breakpoints: {
      768: {
        slidesPerView: 2
      }
    }
  });

  // Initiate tooltip v2
  document.querySelectorAll(".tooltip-v2").forEach((tooltip) => {
    console.log(tooltip);
    const tooltip_icon = tooltip.querySelector(".tooltip-icon");
    const tooltip_content = tooltip.querySelector(".tooltip-content");
    const tooltipInstance = createPopper(tooltip_icon, tooltip_content, {
      placement: "top",
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [-10.5, 10]
          }
        }
      ]
    });

    function show() {
      tooltip_content.setAttribute('data-show', '');

      // We need to tell Popper to update the tooltip position
      // after we show the tooltip, otherwise it will be incorrect
      tooltipInstance.update();
    }

    function hide() {
      tooltip_content.removeAttribute('data-show');
    }

    const showEvents = ['mouseenter', 'focus'];
    const hideEvents = ['mouseleave', 'blur'];

    showEvents.forEach((event) => {
      tooltip_icon.addEventListener(event, show);
    });

    hideEvents.forEach((event) => {
      tooltip_icon.addEventListener(event, hide);
    });
  })


  document.querySelectorAll(".loan-slider").forEach((item) => {
    let slider = new LoanSlider(
      LoanConfigFactory.getConfig(item.getAttribute("type"))
    );
    slider.init(item);
  });

  document.querySelectorAll(".list-section").forEach((item) => {
    new ListSection(item);
  });

  document.querySelectorAll(".image-section").forEach((x) => {
    new Modal(x.querySelector(".modal"), x.querySelector("img"));
  });

  let companiesSections = document.querySelectorAll(".companies-section");
  if (companiesSections.length > 0) {
    companiesSections.forEach((x) => {
      let button = x.querySelector(".button");
      let list = x.querySelector(".companies-section--list");

      button.addEventListener("click", function () {
        if (!x.classList.contains("open")) {
          x.classList.add("open");
        } else {
          x.classList.remove("open");
        }
      });
    });
  }

  document.querySelectorAll("[data-cloak]").forEach(function (el) {
    el.classList.add("element_visible");
  });

  // Enable loans list tabs
  const loan_lists = document.querySelectorAll(".loan-plugin-list-section-2");
  window.loan_lists = loan_lists;

  // console.log("loan_lists", loan_lists);

  if (loan_lists) {
    // LOAN LISTS
    loan_lists.forEach((loan_list) => {
      const loans_list_items = loan_list.querySelectorAll(".loans-list-item");
      if (loans_list_items && loans_list_items.length > 0) {
        const rating_tooltip = loan_list.querySelector(".rating_tooltip");

        // LOAN IN LOAN LIST
        loans_list_items.forEach((el) => {

          const footer_details = el.querySelectorAll(".loan-list-footer-details");
          const footer_details_off = el.querySelectorAll(".loan-list-footer-details-off");


          // TABS V2
          const tabs = el.querySelectorAll(".list-tab");
          tabs.forEach((tab) => {
            // console.log(tab);
            tab.addEventListener("click", (ev) => {

              const tab_name = tab.dataset.tab;
              const tab_content = el.querySelector(".loan-tab-" + tab_name);
              if (tab_content && !tab_content.classList.contains("loan-tab-content-open")) {
                // The tab is hidden
                // close all tabs on the page
                el.querySelectorAll(".loan-tab-content").forEach((tabx) => {
                  tabx.classList.remove("loan-tab-content-open");
                });
                tabs.forEach((el) => {
                  el.classList.remove("tab_open");
                });
                // Open this tab
                tab_content.classList.add("loan-tab-content-open");
                tab.classList.add("tab_open");

              } else if (tab_content) {
                // close this tab
                tab_content.classList.remove("loan-tab-content-open");
                tab.classList.remove("tab_open");
              }

              let has_tab_open = false;
              el.querySelectorAll(".loan-tab-content").forEach((tabx) => {
                if (!has_tab_open) {
                  has_tab_open = tabx.classList.contains("loan-tab-content-open");
                }
              });

              if (has_tab_open) {
                footer_details.forEach(eld => {
                  eld.classList.remove("hidden");
                });
                footer_details_off.forEach(eld => {
                  eld.classList.add("hidden");
                });
              } else {
                footer_details.forEach(eld => {
                  eld.classList.add("hidden");
                });
                footer_details_off.forEach(eld => {
                  eld.classList.remove("hidden");
                });
              }
            });

          });

          // RATING TOOLTIP
          const rating_info = el.querySelector(".rating_info");
          // const rating_tooltip = el.querySelector('.rating_tooltip')

          if (rating_info) {
            "mouseenter touchstart".split(" ").forEach((e) => {
              rating_info.addEventListener(e, (ev) => {
                console.log(ev);
                if (ev.target.classList.contains("tooltip_active")) {
                  rating_tooltip.classList.add("hidden");
                  ev.target.classList.remove("tooltip_active");
                } else {
                  ev.target.classList.add("tooltip_active");
                  rating_tooltip.classList.remove("hidden");
                  createPopper(rating_info, rating_tooltip, {
                    placement: "top",
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, 10]
                        }
                      }
                    ]
                  });
                }
              });
            });

            rating_info.addEventListener("mouseleave", (ev) => {
              rating_tooltip.classList.add("hidden");
              ev.target.classList.remove("tooltip_active");
            });
          }

          //Tabs V1


        });
      }

      const loadMoreButton = loan_list.querySelector(".plugin-loan-list--more");
      if (loadMoreButton) {
        loadMoreButton.removeAttribute('hidden')
        loadMoreButton.addEventListener("click", (ev) => {
          if (loan_list.classList.contains("show-all")) {
            loan_list.classList.remove("show-all");
            loadMoreButton.innerHTML =
              "Visa fler låneaktörer <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\" style=\"margin-left: 5px\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke=\"#56ccf2\" fill=\"none\" stroke-width=\"2\" d=\"M19 9l-7 7-7-7\" /></svg>";
            document.location = "#" + loan_list.id;
          } else {
            loan_list.classList.add("show-all");
            loadMoreButton.innerHTML =
              "Visa färre låneaktörer <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\" style=\"margin-left: 5px\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke=\"#56ccf2\" fill=\"none\" stroke-width=\"2\" d=\"M5 15l7-7 7 7\" /></svg>";
          }
        });
      }


      const tooltips = loan_list.querySelectorAll(".loan-card--table-cell-tooltip-trigger, .loan-card--table-tooltip-trigger");
      // console.log('TOOLTIPS', tooltips);
      let showEvents = ["click", "mouseenter"];
      let hideEvents = ["mouseleave"];

      tooltips.forEach(x => {
        let tooltip = x.querySelector(".loan-card--table-cell-tooltip, .loan-card--table-tooltip");

        showEvents.forEach(evnt => x.addEventListener(evnt, () => {
          tooltip.classList.add('tooltip-open')
        }));

        hideEvents.forEach(evnt => x.addEventListener(evnt, () => {
          tooltip.classList.remove('tooltip-open')
        }));

        // tooltip.querySelector(".loan-card--table-cell-tooltip-close, .loan-card--table-tooltip-close")
        //   .addEventListener("click", e => {
        //     e.target.parentElement.parentElement.classList.remove("open");
        //   });
      });


    });
  }


  const sectionAnchors = [];


  let anchorObserver = new IntersectionObserver((entries, observer) => {
    // console.log( observer)
    entries.forEach((el) => {
      sectionAnchors.forEach((v, k) => {
        if (v.id === el.target.id) {
          sectionAnchors[k].isIntersecting = el.isIntersecting;
        }
      });
    });

    // console.log(sectionAnchors);

    let hasVisible = false;
    sectionAnchors.forEach((el) => {
      if (!el.isIntersecting || hasVisible) {
        el.anchor.classList.remove("active");
      } else {
        el.anchor.classList.add("active");
        hasVisible = 1;
      }
    });


  }, {
    rootMargin: "-75px"
  });
  const anchorSectionList = document.querySelectorAll(".anchor-section--list");
  if (anchorSectionList) {
    anchorSectionList.forEach((anchorSection) => {
      const anchors = anchorSection.querySelectorAll(".anchor-section--item a");
      if (anchors) {
        anchors.forEach(anchor => {
          const href = anchor.getAttribute("href");
          if (href) {
            const id = href.substring(1);
            const el = document.getElementById(id);
            // console.log(el);
            if (el) {
              //   setTimeout(() => {
              sectionAnchors.push({
                id,
                anchor,
                isIntersecting: false
              });
              anchorObserver.observe(el);

              //   }, 3000)
            }


          }
        });
      }
    });
  }

  const loan_school_elements = document.querySelectorAll(".loan-school-element");
  if (loan_school_elements) {
    loan_school_elements.forEach(loanSchoolElement => {
      const header = loanSchoolElement.querySelector(".loan-school-header");
      const plus = loanSchoolElement.querySelector(".loan-school-plus");
      const minus = loanSchoolElement.querySelector(".loan-school-minus");
      const excerpt = loanSchoolElement.querySelector(".loan-school-excerpt");

      if (excerpt) {
        header.addEventListener("click", () => {
          const excerpt_is_hidden = !excerpt.classList.contains("max-h-max");
          if (excerpt_is_hidden) {
            plus.classList.add("hidden");
            minus.classList.remove("hidden");
            excerpt.classList.add("max-h-max");
          } else {
            plus.classList.remove("hidden");
            minus.classList.add("hidden");
            excerpt.classList.remove("max-h-max");
          }
        });
      }
    });
  }

  // const starRatingSelects = document.querySelectorAll('.star-rating-select');
  // if(starRatingSelects){
  //   starRatingSelects.forEach(starRatingSelect => {

  //   })
  // }

  const starRatingControl = new StarRating(".star-rating-select", {
    classNames: {
      active: "gl-active",
      base: "gl-star-rating",
      selected: "gl-selected"
    }
  });


});

window.onload = () => {
  const loansTableCompareWrappers = document.querySelectorAll(
    ".loans-table-compare-wrapper"
  );
  if (loansTableCompareWrappers) {
    loansTableCompareWrappers.forEach((el) => {
      const loansTableCompareScrollable = el.querySelector(
        ".loans-table-compare-scrollable"
      );
      const gradientLeft = el.querySelector(".gradient-l");
      const gradientRight = el.querySelector(".gradient-r");

      // setTimeout(() => {
      // console.log(loansTableCompareScrollable.clientWidth)
      // console.log(loansTableCompareScrollable.querySelector('table').clientWidth)

      // }, 1000)

      if (
        loansTableCompareScrollable.querySelector("table").offsetWidth >
        loansTableCompareScrollable.offsetWidth
      ) {
        gradientRight.classList.remove("hidden");
        gradientLeft.classList.remove("hidden");

        loansTableCompareScrollable
          .querySelector(".last-column-header")
          .classList.add("hidden");
        loansTableCompareScrollable
          .querySelectorAll(".last-column-content")
          .forEach((el) => {
            el.classList.add("hidden");
          });

        loansTableCompareScrollable
          .querySelector(".last-column-header-loop")
          .classList.add("rounded-tr-lg");

        loansTableCompareScrollable.style.cursor = "grab";

        loansTableCompareScrollable
          .querySelectorAll(".first-col-button")
          .forEach((el) => {
            el.classList.remove("hidden");
          });

        const slider = loansTableCompareScrollable;
        let isDown = false;
        let startX;
        let scrollLeft;

        slider.addEventListener("mousedown", (e) => {
          isDown = true;
          slider.classList.add("active");
          startX = e.pageX - slider.offsetLeft;
          scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener("mouseleave", () => {
          isDown = false;
          slider.classList.remove("active");
        });
        slider.addEventListener("mouseup", () => {
          isDown = false;
          slider.classList.remove("active");
        });
        slider.addEventListener("mousemove", (e) => {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - slider.offsetLeft;
          const walk = x - startX; //scroll-fast
          slider.scrollLeft = scrollLeft - walk;
          // console.log(walk);
        });
      }

      loansTableCompareScrollable.addEventListener("scroll", () => {
        const rect = loansTableCompareScrollable.getBoundingClientRect();
        // console.log(loansTableCompareScrollable.scrollLeft)
        // console.log(loansTableCompareScrollable.scrollWidth)

        gradientLeft.style.transform =
          "translateX(-" +
          (40 - loansTableCompareScrollable.scrollLeft) +
          "px)";

        const scrollRight =
          loansTableCompareScrollable.scrollWidth -
          (rect.width + loansTableCompareScrollable.scrollLeft);
        if (scrollRight < 40) {
          gradientRight.style.transform =
            "translateX(" + (40 - scrollRight) + "px)";
        }

        // console.log(loansTableCompareScrollable.getBoundingClientRect())
      });
    });
  }

  const loanButtons = document.querySelectorAll(".loan-button");
  if (loanButtons) {
    loanButtons.forEach((loanButton) => {
      // @ts-ignore
      loanButton.addEventListener("click", () => {
        fetch("/wp-admin/admin-ajax.php?action=external_url&p=" + encodeURIComponent(document.location.href) + "&r=" + encodeURIComponent(loanButton.dataset.externalUrl));
      });
    });
  }


};



// WEBPACK FOOTER //
// ./scripts/main.js